import React from "react";
import ReactDOM from "react-dom/client";
import App from "./AppRouter";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "styled-components";
import { GlobalStyles, darkTheme, lightTheme } from "./style/Global";
import { StoreProvider } from "./providers/storeProvider";
import { normalizeThemeOnBoot } from "./helpers/themeBootstrap";
import { installSafariMediaErrorFilter } from "./helpers/suppressSafariMediaNoise";
import { startHidingStripeLinkUi } from "./helpers/hideStripeLinkUi";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import "./i18n";
import { BrowserRouter } from "react-router-dom";

// Must run before React mounts so the capture-phase listener is in place
// when react-error-overlay attaches its own handler.
installSafariMediaErrorFilter();

// Suppress Stripe Link floating UI (the "stripe >" badge that overlaps the
// PWA bottom nav on iOS Safari after onboarding). Idempotent; runs forever
// to cover late iframe injections from a SetupCard mount.
startHidingStripeLinkUi();

const root = ReactDOM.createRoot(document.getElementById("root"));
normalizeThemeOnBoot(localStorage);

const activeTheme = localStorage.getItem("theme") === "light" ? lightTheme : darkTheme;

root.render(
  // <React.StrictMode>
    <BrowserRouter>
      {/* <Suspense fallback="...is loading"> */}
      <ThemeProvider theme={activeTheme}>
          <StoreProvider>
            <GlobalStyles />
            <App />
          </StoreProvider>
        </ThemeProvider>
        {/* </Suspense> */}
      </BrowserRouter>
    // </React.StrictMode>
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register();
